import { toast } from "react-toastify";
import { t } from "i18next";
import { historyRepository } from "../../../providers/repositories/historyRepository";
import Logger from "../../../utils/Logger";
import type {
  HistoryCollection,
  HistoryTimeline,
} from "../entities/HistoryVersion";

/// Récupère la timeline des versions d'un enregistrement, ainsi que son état courant.
export const getHistoryVersionsUseCase = {
  async exec(
    collection: HistoryCollection,
    recordId: string,
  ): Promise<HistoryTimeline | null> {
    try {
      return await historyRepository.getVersions(collection, recordId);
    } catch (error) {
      toast.error(t("history.loadError"));
      Logger.error("getHistoryVersionsUseCase", error);
    }
    return null;
  },
};
